var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCenarioTopLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 376,
    viewBox: "0 0 228 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45287 1C7.45287 1 256.367 106.29 224.503 211.81C211.323 255.397 182.838 292.689 144.344 316.75C111.505 337.27 54.0454 368.32 -2.00078 375.05V1H7.45287Z",
    fill: "#7AB7DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.98418 0C-1.98418 0 247.885 98.31 217.066 196.82C204.209 237.94 176.325 272.63 139.545 294.82C107.79 314 52.2211 343 -1.98409 349.24L-1.98418 0Z",
    fill: "url(#paint0_linear_1142_157)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5307 209C82.3403 209 71.6474 198.255 71.6474 185C71.6474 171.745 82.3403 161 95.5307 161C108.721 161 119.414 171.745 119.414 185C119.414 198.255 108.721 209 95.5307 209Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7126 159C49.1174 159 43.771 153.627 43.771 147C43.771 140.373 49.1174 135 55.7126 135C62.3078 135 67.6543 140.373 67.6543 147C67.6543 153.627 62.3078 159 55.7126 159Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.465 146C96.1223 146 88.5481 138.389 88.5481 129C88.5481 119.611 96.1223 112 105.465 112C114.809 112 122.383 119.611 122.383 129C122.383 138.389 114.809 146 105.465 146Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6981 120C53.7517 120 49.7418 115.971 49.7418 111C49.7418 106.029 53.7517 102 58.6981 102C63.6444 102 67.6543 106.029 67.6543 111C67.6543 115.971 63.6444 120 58.6981 120Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1142_157",
    x1: 108.858,
    y1: 0,
    x2: 108.858,
    y2: 349.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2980B9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2980B9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenarioTopLeft);
export default __webpack_public_path__ + "static/media/Cenario_top_Left.496c493b56b3051c12e119b195b20f1b.svg";
export { ForwardRef as ReactComponent };